// Sticky "Subscribe now" bar for subscription products. The native sticky add-to-cart
// can't carry a selling plan, so this replaces it: it reveals once the subscription form
// scrolls out of view and its button jumps back up to the form rather than adding to cart.
class SubscriptionStickyCta extends HTMLElement {
  /** @type {HTMLElement | null} */
  bar = null;

  /** @type {HTMLElement | null} */
  button = null;

  /** @type {HTMLElement | null} */
  form = null;

  /** @type {Element | null} */
  target = null;

  /** @type {IntersectionObserver | null} */
  observer = null;

  /** @type {AbortController | null} */
  abortController = null;

  connectedCallback() {
    this.bar = /** @type {HTMLElement | null} */ (this.querySelector('[ref="stickyBar"]'));
    this.button = /** @type {HTMLElement | null} */ (this.querySelector('.sticky-add-to-cart__button'));
    this.form = /** @type {HTMLElement | null} */ (document.querySelector('cheese-club-subscription'));
    // Watch the subscribe button: reveal the bar once it scrolls above the viewport.
    this.target = this.form?.querySelector('.ccs__submit') ?? this.form;
    if (!this.bar || !this.target) return;

    this.abortController = new AbortController();
    const { signal } = this.abortController;

    const bar = this.bar;
    this.observer = new IntersectionObserver(([entry]) => {
      if (!entry) return;
      // Show the bar only once the form has scrolled above the viewport; hide while it's
      // visible or still below the fold (covers a direct above→below jump leaving it stuck).
      if (entry.isIntersecting || entry.boundingClientRect.top > 0) {
        bar.dataset.stuck = 'false';
      } else {
        bar.dataset.stuck = 'true';
      }
    });
    this.observer.observe(this.target);

    // A plain hash jump is unreliable to an element inside a position:sticky column, so
    // scroll explicitly to the form's resolved document position instead.
    const form = this.form;
    this.button?.addEventListener('click', (event) => {
      if (!form) return;
      event.preventDefault();
      const header = /** @type {HTMLElement | null} */ (document.querySelector('#header-component'));
      const offset = (header?.offsetHeight ?? 0) + 16;
      const top = window.scrollY + form.getBoundingClientRect().top - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    }, { signal });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.abortController?.abort();
  }
}

if (!customElements.get('subscription-sticky-cta')) {
  customElements.define('subscription-sticky-cta', SubscriptionStickyCta);
}
